import {
   Notification,
   handleAddNotification,
   handleNotifyError,
   handleNotifyInfo,
   handleNotifySuccess,
   handleNotifyWarning,
   handleRemoveNotification,
   notifications,
} from '@nxtpeople/nxt-styles';

function ensureNotificationKey(notification: Partial<Notification>) {
   return {
      ...notification,
      key: notification.key || `${new Date().toISOString()}${Math.random()}`,
   };
}

export function notify(notification: Notification) {
   return handleAddNotification(ensureNotificationKey(notification));
}

export function notifySuccess(notification: Partial<Notification>) {
   return handleNotifySuccess(ensureNotificationKey(notification));
}

export function notifyError(notification: Partial<Notification>) {
   return handleNotifyError(ensureNotificationKey(notification));
}

export function notifyWarning(notification: Partial<Notification>) {
   return handleNotifyWarning(ensureNotificationKey(notification));
}

export function notifyInfo(notification: Partial<Notification>) {
   return handleNotifyInfo(ensureNotificationKey(notification));
}

export function removeNotification(key: string) {
   return handleRemoveNotification(key);
}

export function updateNotification(notification: Notification) {
   const notificationIndex = notifications.value.findIndex((n) => n.key === notification.key);
   if (notificationIndex < 0) return;

   notifications.value[notificationIndex] = { ...notifications.value[notificationIndex], ...notification };
}
